import { get, post } from "./axiosClient";

type LoginUserProps = {
    login: string,
    password: string
}

type LoginUserResponse = {
    token?: string,
    errorMessage?: string
}

export const getId = async ({ login }: LoginUserProps): Promise<string> => {
    return await get({
        params: {
            name: login
        },
        path: 'login'
    }).then((res) => {
        if (res.status === 200) {
            return  res.data 
        } else {
            return  '' 
        }
    });
}


export const loginUser = async ({ login, password }: LoginUserProps): Promise<LoginUserResponse> => {
    return await post({
        data: {},
        params: {
            name: login,
            password: password
        },
        path: 'login'
    }).then((res) => {
        if (res.status === 200) {
            return { token: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}